import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import apiRequestType from "../../apiRequestType";

const getNotificationTemplate = () => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.ADMIN.ENGAGEMENT_CENTER.GET_NOTIFICATION_TEMPLATE
  );
};

export default getNotificationTemplate;
